<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="410"
    >
    <v-card>
      <v-card-title>
        {{ $t('messages.confirm_remove') }}
      </v-card-title>
    <v-card-actions>
      <v-btn
        color="green"
        dark
        @click="$emit('cancel')"
        >
        {{ $t('buttons.disagree') }}
      </v-btn>
        <v-btn
          color="red darken-1"
          text
          @click="$emit('success')"
          >
          {{ $t('buttons.agree') }}
        </v-btn>
    </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * @name remoceConfirm
 * @description help remove button confirm
 * @version 1.0.0
 * @event success, cancel
 * @property v-model
 */
export default {
  props: {
    value: {
      default: false,
      type: Boolean
    }
  }
}
</script>
